import { useMemo, useState } from "react";

import { SWReactIcons } from "@similarweb/icons";

import { translate } from "app/filters/i18nFilter";

import { SuggestedQueriesView } from "../SuggestedQueriesView";

import { StyledAiButton } from "./styles";

type Props = {
    suggestions: readonly string[];
    onSuggestionClick: (suggestionText: string) => void;
    onShowMoreClick: VoidFunction;
};

export const ContextualSuggestionsStrategy = ({ suggestions, onSuggestionClick, onShowMoreClick }: Props) => {
    const [visibleCount, setVisibleCount] = useState(1);

    const visibleSuggestions = useMemo(() => suggestions.slice(0, visibleCount), [suggestions, visibleCount]);

    const showMoreButton = visibleSuggestions.length < suggestions.length;

    const handleShowMore = (): void => {
        setVisibleCount((prev) => Math.min(prev + 2, 3));
        onShowMoreClick();
    };

    return (
        <SuggestedQueriesView
            title={translate("si.agent.suggestions.optimize-search")}
            suggestions={visibleSuggestions}
            onSuggestionClick={onSuggestionClick}
        >
            {showMoreButton ? (
                <StyledAiButton
                    variant="flat"
                    icon={
                        <SWReactIcons
                            iconName="sparkles-ai"
                            size="xs"
                        />
                    }
                    label={translate("si.agent.suggestions.show-more-ideas")}
                    onClick={handleShowMore}
                />
            ) : null}
        </SuggestedQueriesView>
    );
};
